import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import {
  checkEmailAddressAndSignUp,
  userResetSignUpSuccess,
  resetForm,
  loginRedriect,
} from '../../actions';
import SignUpForm from './forms/SignUpForm';
import SignUpForm2 from './forms/SignUpForm2';
import MyS4CUnAuthNav from './MyS4CUnAuthNav';
import translate from '../TranslateHOC';
import {
  PATH_AUTHENTICATED_REDIRECT,
  EN_FORM_VALUE,
  CY_FORM_VALUE,
} from '../../constants';
import MyS4CAPIErrorAlert from './alerts/MyS4CAPIErrorAlert';
import { USER_SIGNUP_ERROR } from '../../actions/types';
import queryString from 'query-string';
import { device } from '../../v2/Theme';
import { rgba } from 'polished';
import CheckBoxDark from '../../img/icons/check_box_outline_blank_light.svg';
import CheckBoxDarkChecked from '../../img/icons/check_box_light.svg';
import CheckBoxLight from '../../img/icons/check_box_outline_blank_light.svg';
import CheckBoxLightChecked from '../../img/icons/check_box_dark.svg';
import DropdownIcon from '../../img/icons/arrow_drop_down.svg';
import DropdownIconWhite from '../../img/icons/arrow_drop_down_white.svg';

class MyS4CSignUp extends Component {
  // See EditAccountForm for example where error and submission handfling are tied to the form

  constructor(props) {
    super(props);
    this.handleSignUpSubmit = this.handleSignUpSubmit.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = { page: 1 };
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.curLang !== this.props.curLang) {
      this.resetPage();
      this.props.updateForm('signup');
    }

    if (
      nextProps.userSignUpError &&
      nextProps.userSignUpError !== this.props.userSignUpError
    ) {
      this.resetPage();
    }
  };

  UNSAFE_componentWillMount = () => {
    if (this.props.isAuthenticated) {
      this.props.history.push(PATH_AUTHENTICATED_REDIRECT);
    }
    this.props.userResetSignUpSuccess();
  };

  componentDidMount = () => {
    if (this.props.isAuthenticated) {
      /* Update stufff on success */
      this.props.updateForm('signup');
      this.resetPage();
      // inject a qs into redirect heading
      let location = {};
      location.search = queryString.stringify({ sup: 1 });
      location.pathname =
        this.props.stateLoginRedirect &&
        this.props.stateLoginRedirect.length > 0
          ? this.props.stateLoginRedirect
          : PATH_AUTHENTICATED_REDIRECT;
      this.props.history.push(location);
      this.props.loginRedriect();
    }
    window.scrollTo(0, 0);
  };

  UNSAFE_componentWillUpdate = (nextProps) => {
    if (nextProps.isAuthenticated) {
      this.props.history.push(PATH_AUTHENTICATED_REDIRECT);
    }
  };

  componentWillUnmount = () => {
    /* Reset the form when user leaves the page */
    this.props.updateForm('signup');
    this.resetPage();
  };

  resetPage = () => {
    this.setState({ page: 1 });
  };

  nextPage = () => {
    this.setState({ page: this.state.page + 1 });
  };

  previousPage = () => {
    this.setState({ page: this.state.page - 1 });
  };

  handleSignUpSubmit = (values) => {
    const lang =
      parseInt(this.props.curLang, 10) === 1 ? EN_FORM_VALUE : CY_FORM_VALUE;
    const prefLang = values.preferred_language_iso_code
      ? values.preferred_language_iso_code
      : lang;

    if (values.email && values.person_name) {
      return this.props.checkEmailAddressAndSignUp(
        values.email,
        values.person_name,
        values.password,
        values.mail_24228,
        values.gender,
        values.postcode,
        prefLang,
        values.day,
        values.month,
        values.year
      );
    }
  };

  renderAlertMessage = () => {
    const { userSignUpError } = this.props;
    if (userSignUpError && Object.keys(userSignUpError).length > 0) {
      return (
        <MyS4CAPIErrorAlert
          errorMessage={userSignUpError}
          errorType={USER_SIGNUP_ERROR}
        />
      );
    }
  };

  renderFormOrSuccess = () => {
    const success = this.props.userSignUpSuccess;
    const { page } = this.state;

    if (success) {
      return (
        <div>
          <header className="my-s4c-page__header">
            <h2 className="my-s4c-page__title">
              {this.props.strings.thankYou}
            </h2>
          </header>
          <div
            className="my-s4c-page__body my-s4c-page__body--left my-s4c-page__body--pad-btm"
            dangerouslySetInnerHTML={{
              __html: this.props.strings.signUpSuccess,
            }}
          ></div>
        </div>
      );
    } else {
      return (
        <div>
          {page === 1 && (
            <SignUpForm strings={this.props.strings} onSubmit={this.nextPage}>
              {this.renderAlertMessage()}
            </SignUpForm>
          )}

          {page === 2 && (
            <SignUpForm2
              onSubmit={this.handleSignUpSubmit}
              strings={this.props.strings}
              previousPage={this.previousPage}
              curLang={this.props.curLang}
            >
              {this.renderAlertMessage()}
            </SignUpForm2>
          )}
          <div></div>
        </div>
      );
    }
  };

  render() {
    const activeLocation = this.props.location.pathname;
    return (
      <div className="sign-up">
        <SignUpFormContainer>
          <section className="floating-form">
            <MyS4CUnAuthNav active={activeLocation} />
            {this.renderFormOrSuccess()}
          </section>
        </SignUpFormContainer>
        <BackgroundImage className="my-s4c-content__bg" />
      </div>
    );
  }
}

const SignUpFormContainer = styled.section`
  background: ${(props) =>
    props.theme.name === 'light'
      ? 'rgba(251, 251, 251, 0.6);'
      : 'rgba(16, 16, 15, 0.6);'};
  border-radius: 12px;
  box-shadow: ${(props) =>
    props.theme.name === 'light'
      ? '0px 32px 64px rgba(0, 0, 0, 0.075), 0px 16px 32px rgba(0, 0, 0, 0.075), 0px 8px 16px rgba(0, 0, 0, 0.075), 0px 4px 8px rgba(0, 0, 0, 0.075)'
      : '0px 32px 64px rgba(0, 0, 0, 0.075), 0px 16px 32px rgba(0, 0, 0, 0.075), 0px 8px 16px rgba(0, 0, 0, 0.075), 0px 4px 8px rgba(0, 0, 0, 0.075)'};
  backdrop-filter: blur(24px);
  margin: 4.5em 20px;
  max-width: 474px;
  width: calc(100% - 40px);
  z-index: 9999;
  position: relative;
  left: 50%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 8em;
  transform: translateX(-50%);
  a:hover,
  .link:hover {
    box-shadow: none !important;
  }
  @media ${device.tablet} {
    margin-top: 12em;
    .form {
      margin-bottom: 11em;
    }
  }
  .sub-header {
    background: none;
    border-radius: 12px 12px 0 0;
    box-shadow: none;

    .my-s4c-header {
      margin: 0;
    }
  }
  .sub-header a {
    padding-bottom: 23px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull} !important;
    font-size: 18px;
    line-height: 27px;
    &:hover {
      box-shadow: none;
    }
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      border-radius: 4px;
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
  }
  .my-s4c-header__nav--unauth {
    padding-left: 20px !important;
  }
  .my-s4c-header__link--active {
    font-weight: bold;
    &::before {
      bottom: -3px;
      left: 0;
      right: 0;
    }
  }
  .form {
    margin-bottom: 5em;
    max-width: none;
  }
  .form__header {
    margin: 20px 0 24px;
    padding: 0 20px;
  }
  .form__col1,
  .form__col2 {
    margin-top: 0;
    margin-bottom: 2px;
  }
  .form__col1 .form__label,
  .form__col2 .form__label {
    margin-bottom: 0;
  }
  .form__field span {
    display: block;
    margin-bottom: 12px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black90
        : props.theme.color.white90};
    font-size: 16px;
    line-height: 19px;
  }
  .form__suggest,
  .suggest__email {
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull} !important;
  }
  .form--no-btm-pad {
    padding-bottom: 2px;
  }
  .form__instruct--pad-btm {
    padding-bottom: 24px;
  }
  .form__label {
    font-size: 20px;
    line-height: 24px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
    + span {
      text-transform: lowercase;
    }
  }
  .form__input {
    line-height: 22px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
    &--select {
      background: ${(props) =>
        props.theme.name === 'light'
          ? `${props.theme.color.black5} url(${DropdownIcon})
        no-repeat 97%`
          : `${rgba(
              props.theme.color.whiteFull,
              0.05
            )} url(${DropdownIconWhite})
          no-repeat 97%`};
      background-size: 10px 10px;
      background-position-x: calc(100% - 14px);
    }
    &::-webkit-input-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &::-moz-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &:-ms-input-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &:-moz-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    background-color: ${(props) =>
      props.theme.name === 'light'
        ? 'rgba(16, 16, 15, 0.05);'
        : 'rgba(255, 255, 255, 0.05);'};
    border: 1px solid
      ${(props) =>
        props.theme.name === 'light'
          ? 'rgba(0, 0, 0, 0.1)'
          : 'rgba(255, 255, 255, 0.2);'};
    box-shadow: none;
    &:hover,
    &:active,
    &:focus-visible {
      color: ${(props) =>
        props.theme.name === 'dark' && props.theme.color.whiteFull};
    }
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
  }
  .form__forgot {
    position: relative;
    margin: 0 20px 37px;
    font-size: 20px;
    line-height: 24px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.primaryAAA
        : props.theme.color.primaryFull};
    text-decoration: underline;
    text-underline-offset: 2px;
  }
  .form__actions {
    margin: 36px 0 30px;
    > div {
      justify-content: center;
    }
  }
  .alert-error {
    margin-bottom: 23px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
  }
  .form__checkbox-holder .form__field--checkbox {
    margin: 0px 20px 25px;
  }
  .form__checkbox-holder .form__input--checkbox:empty ~ .form__checkbox {
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black75
        : props.theme.color.white75};
    a {
      display: inline-block;
      position: relative;
      text-decoration: none;
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.blackFull
          : props.theme.color.whiteFull};
      &:focus-visible {
        box-shadow: ${(props) => props.theme.focusRing};
        border-radius: 4px;
        outline: none;
      }
      &:focus:not(:focus-visible) {
        outline: none;
      }
      &:after {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 1px;
        border-width: 0 0 1px;
        border-style: solid;
        content: '';
      }
    }
  }
  .form__field--2-digit label,
  .form__field--4-digit label {
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black90
        : props.theme.color.white90};
  }
  .form__checkbox-holder
    .form__input--checkbox:focus-visible
    ~ .form__checkbox:before {
    box-shadow: 0 0 0px 3px
      ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.statusLightFocus
          : props.theme.color.statusDarkFocus};
    border-radius: 2px;
  }
  .form__checkbox-holder .form__input--checkbox:empty ~ .form__checkbox:before {
    ${(props) =>
      props.theme.name === 'light'
        ? `background-image:url(${CheckBoxLight})`
        : `background-image:url(${CheckBoxDark})`}
  }
  .form__checkbox-holder
    .form__input--checkbox:checked
    ~ .form__checkbox:before {
    ${(props) =>
      props.theme.name === 'light'
        ? `background-image:url(${CheckBoxLightChecked})`
        : `background-image:url(${CheckBoxDarkChecked})`}
  }
`;

const BackgroundImage = styled.div`
  max-height: 800px;
  &:before {
    background: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.whiteFull
        : props.theme.color.blackFull};
    content: '';
    display: block;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    transition: opacity 75ms ease;
  }
  &:after {
    background: ${(props) =>
      props.theme.name === 'light'
        ? `
      linear-gradient(180deg, ${rgba(
        props.theme.color.whiteFull,
        0.15
      )} 0%, ${rgba(props.theme.color.whiteFull, 0.15735)} 6.67%, ${rgba(
            props.theme.color.whiteFull,
            0.180184
          )} 13.33%, ${rgba(props.theme.color.whiteFull, 0.219411)} 20%, ${rgba(
            props.theme.color.whiteFull,
            0.2753
          )} 26.67%, ${rgba(
            props.theme.color.whiteFull,
            0.347009
          )} 33.33%, ${rgba(props.theme.color.whiteFull, 0.432101)} 40%, ${rgba(
            props.theme.color.whiteFull,
            0.526288
          )} 46.67%, ${rgba(
            props.theme.color.whiteFull,
            0.623712
          )} 53.33%, ${rgba(props.theme.color.whiteFull, 0.717899)} 60%, ${rgba(
            props.theme.color.whiteFull,
            0.802991
          )} 66.67%, ${rgba(
            props.theme.color.whiteFull,
            0.8747
          )} 73.33%, ${rgba(props.theme.color.whiteFull, 0.930589)} 80%, ${rgba(
            props.theme.color.whiteFull,
            0.969817
          )} 86.67%, ${rgba(props.theme.color.whiteFull, 0.99265)} 93.33%, ${
            props.theme.color.whiteFull
          } 100%),
      linear-gradient(256.01deg, ${rgba(
        props.theme.color.whiteFull,
        0.075
      )} 44.8%, ${rgba(props.theme.color.whiteFull, 0.078675)} 47.31%, ${rgba(
            props.theme.color.whiteFull,
            0.090092
          )} 49.81%, ${rgba(
            props.theme.color.whiteFull,
            0.1097055
          )} 52.32%, ${rgba(
            props.theme.color.whiteFull,
            0.13765
          )} 54.82%, ${rgba(
            props.theme.color.whiteFull,
            0.1735045
          )} 57.33%, ${rgba(
            props.theme.color.whiteFull,
            0.2160505
          )} 59.83%, ${rgba(
            props.theme.color.whiteFull,
            0.263144
          )} 62.34%, ${rgba(
            props.theme.color.whiteFull,
            0.311856
          )} 64.84%, ${rgba(
            props.theme.color.whiteFull,
            0.3589495
          )} 67.35%, ${rgba(
            props.theme.color.whiteFull,
            0.4014955
          )} 69.85%, ${rgba(
            props.theme.color.whiteFull,
            0.43735
          )} 72.36%, ${rgba(
            props.theme.color.whiteFull,
            0.4652945
          )} 74.86%, ${rgba(
            props.theme.color.whiteFull,
            0.4849085
          )} 77.37%, ${rgba(props.theme.color.whiteFull, 0.496325)} 79.87%, ${
            props.theme.color.whiteFull
          } 82.38%),
      linear-gradient(89.96deg, ${props.theme.color.whiteFull} 1.34%, ${rgba(
            props.theme.color.whiteFull,
            0
          )} 50.03%)
    `
        : `
      linear-gradient(180deg, ${rgba(
        props.theme.color.blackFull,
        0.15
      )} 0%, ${rgba(props.theme.color.blackFull, 0.15735)} 6.67%, ${rgba(
            props.theme.color.blackFull,
            0.180184
          )} 13.33%, ${rgba(props.theme.color.blackFull, 0.219411)} 20%, ${rgba(
            props.theme.color.blackFull,
            0.2753
          )} 26.67%, ${rgba(
            props.theme.color.blackFull,
            0.347009
          )} 33.33%, ${rgba(props.theme.color.blackFull, 0.432101)} 40%, ${rgba(
            props.theme.color.blackFull,
            0.526288
          )} 46.67%, ${rgba(
            props.theme.color.blackFull,
            0.623712
          )} 53.33%, ${rgba(props.theme.color.blackFull, 0.717899)} 60%, ${rgba(
            props.theme.color.blackFull,
            0.802991
          )} 66.67%, ${rgba(
            props.theme.color.blackFull,
            0.8747
          )} 73.33%, ${rgba(props.theme.color.blackFull, 0.930589)} 80%, ${rgba(
            props.theme.color.blackFull,
            0.969817
          )} 86.67%, ${rgba(props.theme.color.blackFull, 0.99265)} 93.33%, ${
            props.theme.color.blackFull
          } 100%),
      linear-gradient(256.01deg, ${rgba(
        props.theme.color.blackFull,
        0.075
      )} 44.8%, ${rgba(props.theme.color.blackFull, 0.078675)} 47.31%, ${rgba(
            props.theme.color.blackFull,
            0.090092
          )} 49.81%, ${rgba(
            props.theme.color.blackFull,
            0.1097055
          )} 52.32%, ${rgba(
            props.theme.color.blackFull,
            0.13765
          )} 54.82%, ${rgba(
            props.theme.color.blackFull,
            0.1735045
          )} 57.33%, ${rgba(
            props.theme.color.blackFull,
            0.2160505
          )} 59.83%, ${rgba(
            props.theme.color.blackFull,
            0.263144
          )} 62.34%, ${rgba(
            props.theme.color.blackFull,
            0.311856
          )} 64.84%, ${rgba(
            props.theme.color.blackFull,
            0.3589495
          )} 67.35%, ${rgba(
            props.theme.color.blackFull,
            0.4014955
          )} 69.85%, ${rgba(
            props.theme.color.blackFull,
            0.43735
          )} 72.36%, ${rgba(
            props.theme.color.blackFull,
            0.4652945
          )} 74.86%, ${rgba(
            props.theme.color.blackFull,
            0.4849085
          )} 77.37%, ${rgba(props.theme.color.blackFull, 0.496325)} 79.87%, ${
            props.theme.color.blackFull
          } 82.38%),
      linear-gradient(89.96deg, ${props.theme.color.blackFull} 1.34%, ${rgba(
            props.theme.color.blackFull,
            0
          )} 50.03%)
    `};
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    content: '';
  }
`;

function mapStateToProps(state) {
  return {
    curLang: state.curLang,
    userSignUpError: state.userSignUpError,
    userSignUpSuccess: state.userSignUpSuccess,
    stateLoginRedirect: state.loginRedirect,
  };
}

export default translate(
  connect(mapStateToProps, {
    checkEmailAddressAndSignUp,
    userResetSignUpSuccess,
    updateForm: resetForm,
    loginRedriect,
  })(MyS4CSignUp)
);
